'use client'

import { FC, useState, useMemo, useEffect } from 'react'
import Image from 'next/image'
import { getDateFromISODate, sanitizeHtml } from '@/root/shared-helpers/utils/utils'
import { News } from '@/root/shared-types/sales-static/sales-static-types'

const linkify = (text: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:opacity-80">${url}</a>`
  })
}

export const Notification: FC<News> = ({ subject, published_at, body, image }) => {
  const imageSrc = image?.url ? `/api${image.url}` : ''
  const [imageOk, setImageOk] = useState(true)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const sanitizedBody = useMemo(() => {
    const linkified = linkify(body ?? '')
    return sanitizeHtml(linkified)
  }, [body])

  return (
    <article className="mx-auto flex w-full max-w-[1180px] justify-between">
      <div className="flex w-full">
        <div className="flex w-full min-w-0 flex-col gap-[5px]">
          <h2 className="text-lg leading-tight font-semibold text-black">{subject}</h2>

          <p className="text-neutral-medium-light text-sm leading-none">
            {getDateFromISODate({ isoDate: published_at })}
          </p>

          <div
            className="mt-0 leading-normal break-words whitespace-pre-wrap text-black [&_a]:text-blue-600 [&_a]:underline"
            dangerouslySetInnerHTML={mounted ? { __html: sanitizedBody } : undefined}
          >
            {!mounted ? body : null}
          </div>

          {!!imageSrc && imageOk && (
            <div className="relative mt-2 h-52 w-80 shrink-0 overflow-hidden rounded-md bg-white">
              <Image
                src={imageSrc}
                alt={image?.alternativeText ?? subject}
                fill
                sizes="320px"
                className="object-contain object-left-top"
                onError={() => setImageOk(false)}
              />
            </div>
          )}
        </div>
      </div>
    </article>
  )
}
